"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgClockFastForward = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12 4a8 8 0 1 0 6.223 13.028 1 1 0 0 1 1.554 1.258A9.983 9.983 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c5.134 0 9.365 3.87 9.935 8.851l.058-.058a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.413 0l-2.001-2a1 1 0 0 1 1.414-1.414l.568.568A8 8 0 0 0 12 4Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .445.832l3 2a1 1 0 0 0 1.11-1.664L13 11.465V7Z", fill: "currentColor" })] }))); };
exports.default = SvgClockFastForward;
